import i18n from '@/vueI18n';

export interface ICreativeTrackingUrlAPI {
  creativetrackingurl_id: number;
  creative_id: number;
  trackingurl: string;
  multiple_calls: boolean;
}

export const creativeTrackingUrlMacros: { name: string }[] = [
  { name: 'DSP' },
  { name: 'SSP' },
  { name: 'CRID' },
  { name: 'SCHEDULED_TIMESTAMP' },
  { name: 'IMPRESSIONS' },
  { name: 'OWNER' },
  { name: 'UNITID' },
];

export default class CreativeTrackingUrl {
  id: number;

  creativeID: number;

  trackingUrl: string;

  multipleCalls: boolean;

  constructor(id = -1, creativeID: number, trackingUrl: string, multipleCalls = false) {
    this.id = id;
    this.creativeID = creativeID;
    this.trackingUrl = trackingUrl;
    this.multipleCalls = multipleCalls;
  }

  static fromApi(apiObject: ICreativeTrackingUrlAPI): CreativeTrackingUrl {
    return new CreativeTrackingUrl(
      apiObject.creativetrackingurl_id,
      apiObject.creative_id,
      apiObject.trackingurl,
      apiObject.multiple_calls,
    );
  }

  toApi(): ICreativeTrackingUrlAPI {
    return {
      creativetrackingurl_id: this.id >= 0 ? this.id : undefined,
      creative_id: this.creativeID,
      trackingurl: this.trackingUrl,
      multiple_calls: this.multipleCalls,
    };
  }

  toString(): string {
    return `${this.trackingUrl} (${this.multipleCalls ? i18n.global.t('messages.perImpression') : i18n.global.t('messages.perPlay')})`;
  }
}
